export default {
    setTariffSettings(state, payload)
    {
        state.tariff_list = payload;
    },
    setBalanceModalIsOpen(state, payload)
    {
        state.balanceModalIsOpen = payload;
    }
}